import s from "./style.module.css";
export interface Input {
    "poster-video": Marko.AttrTag<Marko.HTML.Video>;
    "dialog-video": Marko.AttrTag<Marko.HTML.Video>;
    aspectRatio?: "16/9" | "5/4" | "3/2";
}
static function isOpen(state: string) {
    return state === "open" || state === "opening";
}
static function handleTransition(fn: () => void) {
    if (!document.startViewTransition) {
        fn();
        return { finished: Promise.resolve() };
    } else {
        return document.startViewTransition(fn);
    }
}
// Input
<const/{
    aspectRatio,
    "poster-video": posterVideo,
    "dialog-video": dialogVideo,
}=input>
// Poster state vars
<let/reduceMotion=false>
<let/isVisible=false>
<let/systemPaused=true>
<let/userPaused=undefined as boolean | undefined>
<const/shouldPlay=isVisible && !(userPaused ?? systemPaused)>
// Dialog state Vars
<let/openState="closed">
<let/showButton=true>
// Utilities
<const/toggleOpen=(nextOpen: boolean) => {
    if (!dialogVideoRef().paused) dialogVideoRef().pause();

    if (!reduceMotion) {
        posterVideoRef().style.viewTransitionName = `video-lightbox`;
        dialogVideoRef().style.viewTransitionName = `video-lightbox`;
    }

    const { finished } = handleTransition(() => {
        if (nextOpen) dialogRef().showModal();
        else dialogRef().close();
        openState = nextOpen ? "opening" : "closing";
    });

    finished.then(() => {
        posterVideoRef().style.viewTransitionName = "";
        dialogVideoRef().style.viewTransitionName = "";
        openState = nextOpen ? "open" : "closed";
        showButton = nextOpen ? false : true;
        if (openState === "open") dialogVideoRef().play();
    });
}>

<script>
    if (shouldPlay) posterVideoRef().play();
    else posterVideoRef().pause();
</script>

<div class=s.container>
    <video/posterVideoRef
        ...posterVideo
        class=[s.video, posterVideo.class]
        src=posterVideo.src
        data-aspect-ratio=aspectRatio
        muted
        loop
        playsinline
        onPause() {
            systemPaused = true;
        }
        onPlay() {
            systemPaused = false;
        }
        style={
            display: isOpen(openState) ? "none" : "block",
        }/>
    <evo-button
        class=s.play
        style={ opacity: showButton ? 1 : 0 }
        onClick() {
            toggleOpen(true);
        }>
        <@icon position="start">
            <icon-play-20/>
        </@icon>
        Play Video
    </evo-button>
    <play-button
        aria-label=`${shouldPlay ? "Pause" : "Resume"} video`
        paused=!shouldPlay
        class=s.allyButton
        onClick() {
            userPaused = shouldPlay;
        }/>
    <script>
        const prm = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
        ).matches;
        userPaused = prm;
        reduceMotion = prm;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) isVisible = true;
            else isVisible = false;
        });
        observer.observe(posterVideoRef());
        $signal.onabort = () => {
            observer.unobserve(posterVideoRef());
            observer.disconnect();
        };
    </script>
</div>
<dialog/dialogRef
    class=s.dialog
    data-color="black"
    onClick(e) {
        if (e.target === dialogRef()) {
            e.preventDefault();
            toggleOpen(false);
        }
    }
    onKeyDown(e) {
        if (openState.includes("ing")) {
            e.preventDefault();
        } else if (e.key === "Escape") {
            e.preventDefault();
            toggleOpen(false);
        }
    }>
    <video/dialogVideoRef
        ...dialogVideo
        class=[s.video, dialogVideo.class]
        data-aspect-ratio="16/9"
        controls
        playsinline/>
    <icon-button
        class=s.closeButton
        aria-label="close-modal"
        onClick() {
            toggleOpen(false);
        }>
        <icon-close-20/>
    </icon-button>
</dialog>
